import React, { useContext } from "react"
import { Box, ButtonGroup, Button } from "@mui/material"
import { useNavigate, useLocation } from "react-router-dom"
import { UserContext } from "src/providers"
import { getPath, Tablet } from "src/models/company"

interface NavButtonProps {
  icon: string
  label: string
  path: string
}

const NavButton: React.FC<NavButtonProps> = ({ icon, label, path }) => {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <Button
      startIcon={<img src={icon} alt="" style={{ width: "18px", height: "18px" }} />}
      onClick={() => navigate(path)}
      sx={{
        backgroundColor: location.pathname === path ? "#CEF5FE" : "transparent"
      }}
    >
      {label}
    </Button>
  )
}

export const TabletNavigation = () => {
  const { tablets } = useContext(UserContext)
  const translateFilePath = getPath(tablets.find((t) => t.name === "instant") as Tablet)

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        py: "11.5px",
        px: 2,
        backgroundColor: "#FAFAFA"
      }}
    >
      <ButtonGroup
        variant="outlined"
        sx={{
          width: "100%",
          "& .MuiButton-root": {
            borderColor: "#E0E0E0",
            textTransform: "none",
            fontSize: "12px",
            px: 3,
            py: 0.5,
            minWidth: "90px",
            flex: 1,
            "&:hover": {
              backgroundColor: "#CEF5FE"
            }
          }
        }}
      >
        <NavButton icon="/exfluency/icons/icon-ai-text-trans.svg" label="Text" path="/text" />
        <NavButton icon="/exfluency/icons/icon-ai-file-trans.svg" label="File" path={translateFilePath} />
        <NavButton icon="/exfluency/icons/icon-ASK.svg" label="ASK" path="/km-chat" />
      </ButtonGroup>
    </Box>
  )
}
